import { FilterItem, SortItem } from "namirasoft-core";
import { EntityType } from "namirasoft-expert";
import { NamirasoftInfraServer } from "namirasoft-infra";

export type InfraEntity = { id: string; name: string; description?: string | null };

export function listInfraEntities(
    infra: NamirasoftInfraServer,
    entity_type: EntityType,
    filters: FilterItem[] | null,
    page: number | null,
    size: number | null,
    sorts: SortItem[],
): Promise<{ rows: InfraEntity[]; count: number }>
{
    switch (entity_type)
    {
        case EntityType.Cloud:
            return infra.cloud.List(filters, page, size, sorts, null);
        case EntityType.Server:
            return infra.server.List(filters, page, size, sorts, null);
        case EntityType.Kubernetes:
            return infra.kubernetes.List(filters, page, size, sorts, null);
        case EntityType.Container:
            return infra.container.List(filters, page, size, sorts, null);
        case EntityType.Database:
            return infra.database.List(filters, page, size, sorts, null);
        case EntityType.Cache:
            return infra.cache.List(filters, page, size, sorts, null);
        case EntityType.Messaging:
            return infra.messaging.List(filters, page, size, sorts, null);
        case EntityType.Streaming:
            return infra.streaming.List(filters, page, size, sorts, null);
        case EntityType.Metric:
            return infra.metric.List(filters, page, size, sorts, null);
    }
}